import React, { Component, PropTypes } from 'react'
import Select from 'react-select'
import { connect } from 'react-redux'
import Modal from '../../components/Modal'
import { updateLockStatus } from '../../actions/ClientActions'

@connect(state => ({
    isUpdatingLockStatus: state.modal.isUpdatingLockStatus,
    errorUpdatingLockStatus: state.modal.errorUpdatingLockStatus,
}))
export default class LockStatusModal extends Component {
    static propTypes = {
        client: PropTypes.shape({
            id: PropTypes.string.isRequired,
        }),
    }

    constructor(props) {
        super(props)
        this.state = {
            newLockStatus: null,
        }
    }

    update() {
        this.props.dispatch(
            updateLockStatus(this.props.client.id, this.state.newLockStatus.value)
        )
    }

    handleUpdateLockStatus(value) {
        this.setState({
            newLockStatus: value,
        })
    }

    // TODO Update when Fergus accepts NULL
    lockOptions = [
        { value: 'Locked', label: 'Locked' },
        { value: 'Unlocked', label: 'Unlocked' },
    ]

    render() {
        var actionButton = this.props.isUpdatingLockStatus ? (
            <button className="btn btn-success disabled">Updating...</button>
        ) : (
            <button
                className="btn btn-success"
                onClick={this.update.bind(this)}
            >
                Update
            </button>
        )

        return (
            <Modal
                actionButton={actionButton}
                className="modal modal-success"
                title={'Update Lock Status'}
            >
                {this.props.client.lockStatus && (
                    <h2>Current Lock Status: {this.props.client.lockStatus}</h2>
                )}
                <label htmlFor="newLockStatus">Update Client Lock:</label>
                <Select
                    placeholder="Select New Lock Status..."
                    multi={false}
                    name="newLockStatus"
                    value={this.state.newLockStatus}
                    options={this.lockOptions}
                    onChange={this.handleUpdateLockStatus.bind(this)}
                />
                <div
                    style={{
                        margin: '3rem auto 3rem auto',
                        textAlign: 'center',
                        maxWidth: '50%',
                    }}
                >
                    <p
                        className="text-muted"
                        style={{ fontSize: 10, paddingTop: 10 }}
                    >
                        Please remember to lock the client in the future to
                        enforce payment of overdue invoice for this billing period.
                    </p>
                    {this.props.errorUpdatingLockStatus && (
                        <p className="text-danger">
                            Error updating lock status!
                        </p>
                    )}
                </div>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./app/components/clients/LockStatusModal.js